var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inline-block released-po-container" }, [
    _c("div", { staticClass: "row released-po" }, [
      _c("label", { staticClass: "small-6 released-po__select" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("project.submission.releasedPo")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "small-6" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("project.submission.glDate")) + "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "small-6 released-po__select",
          class: { readonly: !_vm.isOpen },
        },
        [
          _vm.isOpen && _vm.isPic
            ? [
                _c("HKLSelect", {
                  attrs: { options: _vm.releasedPoOpts },
                  model: {
                    value: _vm.releasedPo,
                    callback: function ($$v) {
                      _vm.releasedPo = $$v
                    },
                    expression: "releasedPo",
                  },
                }),
                _vm._v(" "),
                _vm.showErrHint
                  ? _c("p", { staticClass: "text_red" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("hint.noAvailableReleasedPo")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]
            : _c(
                "p",
                [
                  _vm.isAccepted
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("isEmptyValue")(_vm.releasedPo)) +
                            "\n        "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("emptyValue")) +
                            "\n        "
                        ),
                      ],
                ],
                2
              ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "small-6 released-po__date",
          class: { readonly: !_vm.isOpen },
        },
        [
          _c(
            "p",
            [
              _vm.isAccepted || _vm.isPic
                ? [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("isEmptyValue")(_vm.displayGlDate)) +
                        "\n        "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("emptyValue")) +
                        "\n        "
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }